/**
 * Article's Status
 */

export const STATUS_DRAFT = 1;
export const STATUS_PENDING = 3;
export const STATUS_PUBLISH = 5;
export const STATUS_UNPUBLISH = 7;

/**
 * Article's content types
 */
export const CONTENT_TYPE_DOC = 1;
export const CONTENT_TYPE_IMAGE = 2;
export const CONTENT_TYPE_IMAGES = 3;
export const CONTENT_TYPE_VIDEO = 4;
export const CONTENT_TYPE_HTML = 5;
export const CONTENT_TYPE_FOLDER = 7;
export const CONTENT_TYPE_JOB_DESCRIPTION = 8;
export const CONTENT_TYPE_QUIZZ = 9;

/**
 * Article's type
 */
export const DOCUMENT_TYPE_DOC = 1;
export const DOCUMENT_TYPE_IMAGE = 2;
export const DOCUMENT_TYPE_VIDEO = 4;

/**
 * Article's Bouchon Type
*/
export const BLOC_BOUCHON_EARN_POINTS = 'howToEarnPoints';
export const BLOC_BOUCHON_LAST_EDITION = 'lastEdition';

/**
 * Article's channels
 */
export const PUBLICATION_CHANNEL_KIDSMATIN   = 'kidsmatin';




// WEBPACK FOOTER //
// ./src/conf/constantArticle.js